// extracted by mini-css-extract-plugin
module.exports = {"result":"styles__result___34y72","selectedContact":"styles__selectedContact___2QF9v styles__result___34y72","avatar":"styles__avatar___3qBff"};